import React, { Fragment } from "react";

import {ProductForm} from 'components';
import {ProductList} from 'components';
import {ClientList} from 'components';
import {UserProfile} from 'components';
import Select from 'react-select';
import {
    Alert , UncontrolledAlert ,
    Row, Col,
} from 'reactstrap';
//import CatInputs from 'components'
//import {ProdutListBoard} from './components/common/ProductListBoard/ProductListBoard';
//import ReactDOM from "react-dom";
/* const test=()=>{
    return <h1>welcome to all</h1>
 }

 const scaryAnimals = [
  { label: "Alligators", value: 1 },
  { label: "Crocodiles", value: 2 },
  { label: "Sharks", value: 3 },
  { label: "Small crocodiles", value: 4 },
  { label: "Smallest crocodiles", value: 5 },
  { label: "Snakes", value: 6 },
];*/
const listyle={
  
  display: 'block',
  width: '300px',
  height: '50px',
  padding: '15px',
 
  color: '#fff',
  background: 'lightgray',
  border:'1px solid white',
  'marginLeft': '20px',
  position: 'relative',

}
const scrollstyle={
  "height":"500px",
  "overflowY": "scroll",
}



class Layout5 extends React.Component
{

    intervalID;
    api;
    v1=[];
    temp={};
    constructor(props)
    {
          super(props);
            this.state={inputFields:[{gtpoption: '', gtpvalue: '',prohead:false,dispord:'' }],search:"",searchresult:[],productlist:[],productlistduplicate:[],curproductid:'',alertvisible:false,
                 alesrtsuccessmess:"",childprop:{}};
            this.baseState = this.state;
            this.inputdefault=this.state.inputFields;
      
            this.productistChange=this.productistChange.bind(this);
             this.onDismiss = this.onDismiss.bind(this);
             this.handleSubmit  = this.handleSubmit.bind(this);
    }

    componentDidMount() 
    {
        this.getData();
        this.getProductData();
                  //console.log(window.$apibase);

                  //UserProfile.setName("gobi");
                  //console.log("user profile="+UserProfile.getName());
                  //const { history } = this.props;
        var BASEDIR = process.env.REACT_APP_BASEDIR;
                  //UserProfile.setUid(0);
                  //console.log("uid="+UserProfile.getUid());
        if(UserProfile.getUid()===0)
        {
           
            this.props.history.push(BASEDIR+"/login");
         }
    }

    componentWillUnmount()
    {
        /*
          stop getData() from continuing to run even
          after unmounting this component. Notice we are calling
          'clearTimeout()` here rather than `clearInterval()` as
          in the previous example.
        */

        clearTimeout(this.intervalID);
        
    }

    getData = () => {
          //console.log("get data calling="+new Date().toLocaleString());
           
          if(this.state.search)
            {

                this.api=window.$apibase+"/api/gtplist/?search="+this.state.search;
            }
          else
            {
                this.api=window.$apibase+"/api/gtplist?search=";
            }
          fetch(this.api)
          .then(response => response.json())
          .then(data => {
              this.setState({ searchresult: [...data] });
                        // call getData() again in 10 seconds  10000
                        //this.intervalID = setTimeout(this.getData.bind(this), 100000);
          });
                        //this.intervalID = setTimeout(this.getData.bind(this), 100000);
    }

    getProductData = (pro) => {
                //console.log("get data calling="+new Date().toLocaleString());
       this.api=window.$apibase+"/api/prodtlist?wnew=1&withoutgtp=1";
      if(pro)
        {

            this.api=window.$apibase+"/api/prodtlist?wnew=1&withoutgtp=1&prname="+pro;
        }
      else
        {
            this.api=window.$apibase+"/api/prodtlist?wnew=1&withoutgtp=1";
        }
        fetch(this.api)
        .then(response => response.json())
        .then(data => {
             // this.setState(this.baseState);  
        let templist={'label':'Select','value':''};
        this.setState({ productlist: [...data] });
        this.setState({productlistduplicate: [...data,templist] });
           
        });
    }

    searchSpace=(ev)=>{

        let keyword = ev.target.value;
        this.setState({search:keyword});
        this.getData();
            //console.log(keyword);
    }

    Clearsearch=(eve)=>{
              //console.log("clear search werking start");
        this.setState({search:""});
        this.state.search='';
        this.searchSpace(eve);
                   /*const event = new Event("input", { bubbles: true });
                   const input = document.getElementById("searchtxt");
                   input.dispatchEvent(event);
                //console.log("clear search werking end");
                this.getData();*/

    }

    itemClick=(e)=>{
          this.temp={};
          this.v1=[];
          this.temp.gtpoption= e.target.dataset.key;
          this.temp.gtpvalue=e.target.dataset.value;
          this.temp.prohead=(e.target.dataset.header===1?true:false);
          this.temp.proheader=e.target.dataset.header;
          this.temp.productid=this.state.curproductid;
          this.temp.dispord=10000;


          this.v1.push(this.temp);
                                //console.log("at itemclick");
                                //console.log(this.v1);
          this.setInputFields(this.v1,true);
          this.temp={};
    }

    setInputFields(prvalues,merger=false){
                //console.log("calling +"+prvalues +"  "+merger);
                //console.log(prvalues);
        if(merger)
            {
                //console.log("at merger");
              this.setState(prevState => {return {
                     inputFields: [...prevState.inputFields, prvalues[0]]
                     }

              });
            }
        else
        {
              this.setState({inputFields: prvalues.map((item, itemIndex) => {
                          ////console.log(prvalues);
                    if(item.proheader==="True" || item.proheader===1)
                        item.prohead=true;
                    else
                        item.prohead=false;
                  const list=item
                  return list;  
              })
              },this.myFunction);
              this.forceUpdate();
        }
  
    };


                  myFunction = () => {
                  //console.log("my func calling");
                    //console.log(this.state.inputFields);
                     
                  }


    demo=()=>{
      
      this.state.inputFields.map((values,index)=>{
        return "<span>{values.gtpoption}</span>"
    
      })
    }

    handleAddFields = () => {
              //console.log("add fileds clikde");
        const values = [...this.state.inputFields];
        values.push({ gtpoption: '', gtpvalue: '', prohead:false,dispord:''});
        this.setInputFields(values);
      };

  handleRemoveFields = (index,e) => {
                        //console.log("removed idex"+index);
    const values = [...this.state.inputFields];
    values.splice(index, 1);
    this.setInputFields(values);
                                            //this.handleInputChange(index,e);
                                          /*this.setState({
                                              inputFields:this.state.inputFields.filter((s, sidx) => index !== sidx)
                                          }); */
                                      /*
                                      https://www.robinwieruch.de/react-state-array-add-update-remove
                                          this.setState(state => {
                                            state.inputFields:values;
                                            return inputFields;
                                          }); */
                                          //console.log(values);
  };

  handleInputChange = (index, event) => {
    const values = [...this.state.inputFields];
        if (event.target.name === "gtpoption") 
        {
              values[index].dispord=index;
              values[index].gtpoption = event.target.value;
        }
        else if(event.target.name === "prohead")
        {
                                      console.log(event.target.checked);
              values[index].prohead = event.target.checked;

              const item = event.target.name;
              const isChecked = event.target.checked;
              values[index].prohead =isChecked;
              //this.setState(prevState => ({ inputFields: prevState.inputFields.set(item, isChecked) }));

        }
        else 
        {
              values[index].dispord=index;
              values[index].gtpvalue = event.target.value;
        }
        this.setState({values});
    //this.setInputFields(values);
    this.demo();
  };


  selecteChange=(opt)=>{
        this.setState({alertvisible:false});
                    //console.log(opt.label+"  "+opt.value);
        this.setState({
              curproductid:opt.value

        });
  
      if(opt.value && opt.value>0)
          this.getProductGTP(opt.value);
      else
      {

        this.setState(this.inputdefault);

      } 
  }

  selecteChangeduplicate=(opt)=>{
      this.setState({alertvisible:false});
          if(opt.value && opt.value>0)
            this.getProductGTP(opt.value);
          else
          {
  
              this.setState(this.inputdefault);
  
          } 
  }
    getProductGTP= (pro) => 
    {
          //console.log("get data calling="+new Date().toLocaleString());
           this.api=window.$apibase+"/api/productgtplist";
          if(pro)
          {
    
            this.api=window.$apibase+"/api/productgtplist?prname="+pro;
          }
          else
          {
              this.api=window.$apibase+"/api/productgtplist";
          }
            fetch(this.api)
              .then(response => response.json())
              .then(data => {
                //this.setState({ productlist: [...data] });
                ////console.log(data);
                 this.setState(this.inputdefault);
                this.setInputFields(data);
               
              });
    
    


          
    }


    handleSubmit = (e) => {
    e.preventDefault();
                          // console.log("inputFields", this.state.inputFields);
        if(this.state.curproductid>0)
        {
                // to save gtp details
                const formData = new FormData(); 
        

            this.state.inputFields.map((inputField, index) => (

                 inputField.dispord=index
            ))

            formData.append("gtp",JSON.stringify(this.state.inputFields)); 
            formData.append("prid",this.state.curproductid); 
            fetch(window.$apibase+"/api/gtp", {
                method: 'POST',
                                    // We convert the React state to JSON and send it as the POST body
                body: formData,
                                    //headers: { 'Content-Type': 'application/json' },
                                    //body: JSON.stringify(this.state)
                }).then(function(response) {
                  return response.json();
                }).then((data) => {
                                  //console.log("data="+data);
                                  //e.target.reset();
                                  //document.getElementById("gtpform").reset();
                  this.getData();
                  this.setState(this.baseState);
                      if(data==='')
                          this.setState({alesrtsuccessmess:"saved sucessfully",alertvisible:true});
                      else 
                          this.setState({alesrtsuccessmess: data+" saved sucessfully",alertvisible:true});  
                      this.getProductData();
                                //this.setState(this.inputdefault);

                  });
                                //console.log(this.state.inputFields);
                  this.forceUpdate();
        }
        else
            alert("Please select the Product in GTP");
      
    };

    productistChange(plist){
                          //this.setState({ productlist: [...plist] });
                          //console.log(plist)
        this.setState(prevState => {this.setState({childprop:plist});
              return {
                              // productlist: [...prevState.productlist, plist.result]
                         productlist: [...prevState.productlist,plist]
                      }
    
              });
    }
    onDismiss() {
            this.setState({ alertvisible: false });
      }

    render()
    {

      return (
        <>
   
            <div>

              <div className="content">
               <section className="box">
               <header className="panel_header"><h2 className="title float-left">Client Pdf</h2></header>
                  <div className="content-body"> 
                      <h1></h1>
                      <div className="col-md-12">
                        <div className="form-row">
                          <div className="col-md-9">
                          <ProductList name="prdlist"/>
                          </div>
                        </div>
                      </div>
                  </div>
                </section>
                <section className="box">
                <header className="panel_header"><h2 className="title float-left">Client List</h2></header>
                  <div className="content-body"> 
                       <div className="col-md-12">
                        <div className="form-row">
                          <div className="col-md-9">
                          <ClientList name="prdlist"/>
                          </div>
                        </div>
                      </div>
                  </div>
                </section> 
              <ProductForm onChange={this.productistChange}/>
               <section className="box">
                <header className="panel_header"><h2 className="title float-left">GTP Details Form</h2></header>
               <div className="content-body">
                 
              <div className="col-md-12">
              <div className="form-row">
              <div className="col-md-9">
              <form onSubmit={this.handleSubmit.bind(this)} id="gtpform">
                  <Alert color="success" isOpen={this.state.alertvisible} toggle={this.onDismiss}>
                      {this.state.alesrtsuccessmess}.
                  </Alert>
                  <div className="form-row">
                      <div className="form-group col-sm-3">
                        <label htmlFor="prselect">Product Name</label>
                          <Select name="prselect" options={this.state.productlist}  onChange={opt => this.selecteChange(opt)} />
                      </div>
                      <div className="form-group col-sm-3">
                        <label htmlFor="prselect">Duplicate From </label>
                          <Select name="prselect" options={this.state.productlistduplicate}  onChange={opt => this.selecteChangeduplicate(opt)} />
                      </div>
                  </div>
                  {this.state.inputFields.map((inputField, index) => (
                  <div key={`${index}`} className="form-row">

                 
                    <Fragment key={`${inputField}~${index}`}>
                      
                      <div className="form-group col-sm-4">
                        <label htmlFor="gtpoption">GTP Option</label>
                        <input
                          type="text"
                          className="form-control"
                          
                          name="gtpoption"
                          value={inputField.gtpoption}
                          onChange={event => this.handleInputChange(index, event)}
                        />
                        <input type="hidden" name="dispord" value={this.state.dispord}/>
                      </div>
                      <div className="form-group col-sm-4">
                        <label htmlFor="gtpvalue">GTP Value</label>
                        <input
                          type="text" 
                          className="form-control" 
                          
                          name="gtpvalue"
                          value={inputField.gtpvalue}
                          onChange={event => this.handleInputChange(index, event)}
                        />
                      </div>
                      <div className="form-group col-sm-1">
                        <label htmlFor="gtpvalue">Heading</label>
                        <input
                          type="checkbox" 
                          className="form-control" 
                          
                          name="prohead"
                          checked={inputField.prohead}
                          onChange={event => this.handleInputChange(index, event)}
                        />
                      </div>
                      <div className="form-group col-sm-2">
                        <button
                          className="btn btn-link"
                          type="button"
                          onClick={() => this.handleRemoveFields(index)}
                        >
                          -
                        </button>
                        <button
                          className="btn btn-link"
                          type="button"
                          onClick={() => this.handleAddFields()}
                        >
                          +
                        </button>
                      </div>
                    </Fragment>

                    </div>
                  ))}
                
                <div className="submit-button">
                  <button
                    className="btn btn-primary mr-2"
                    type="submit"
                    onSubmit={()=>this.handleSubmit}
                  >
                    Save GTP
                  </button>
                </div>
                <br/>
                
              </form>
              </div>

              <div className="col-md-3" style={scrollstyle}>
              <input className="form-control" type="text" placeholder="Enter item to be searched"  id="searchtxt"  value={this.state.search}  onChange={(e)=>this.searchSpace(e)} />
              <button className="btn btn-danger" onClick={(eve)=>this.Clearsearch(eve)}>Clear</button>
               {  this.state.searchresult.map((sres, index) => (
                            <li  key={Date.now()+index} style={listyle} data-key={sres.gtpname} data-value={sres.gtpvalue} data-header={sres.gtpisheader} onClick={this.itemClick}>{sres.gtpname}</li>
                        )) 


                        };
              <pre>
                  {


                 /* JSON.stringify(this.state.inputFields, null, 2) */}

                   {   /*test()
                      this.demo() */
                   }
                    
                </pre>
              </div>
              </div>
              </div>
              </div>
               </section>
               
              </div>
              </div>
     
        </>
    );

  }
    
}

export default Layout5;
